import { SDUIBannerRenderer } from "@faire/retailer/components/SDUI/ComponentRenderers/Banner/SDUIBannerRenderer";
import { SDUICarouselRenderer } from "@faire/retailer/components/SDUI/ComponentRenderers/Carousel/SDUICarouselRenderer";
import { SDUIGridRenderer } from "@faire/retailer/components/SDUI/ComponentRenderers/Grid/SDUIGridRenderer";
import { SDUIHeaderRenderer } from "@faire/retailer/components/SDUI/ComponentRenderers/Header/SDUIHeaderRenderer";
import { SDUICategoryPageLayoutElementRenderer } from "@faire/retailer/components/SDUI/ComponentRenderers/LayoutElement/SDUICategoryPageLayoutElementRenderer";
import { SDUISpacerRenderer } from "@faire/retailer/components/SDUI/ComponentRenderers/Spacer/SDUISpacerRenderer";
import { BannerLoadingSkeleton } from "@faire/retailer/components/SDUI/LoadingRenderers/Components/BannerLoadingSkeleton";
import { CarouselLoadingSkeleton } from "@faire/retailer/components/SDUI/LoadingRenderers/Components/CarouselLoadingSkeleton";
import { ComponentRenderMap } from "@faire/retailer/components/SDUI/types";

export const hubComponentRenderers: ComponentRenderMap = {
  layout_element: {
    active: SDUICategoryPageLayoutElementRenderer,
    pending: CarouselLoadingSkeleton,
  },
  carousel_component: {
    active: SDUICarouselRenderer,
    pending: CarouselLoadingSkeleton,
  },
  banner_component: {
    active: SDUIBannerRenderer,
    pending: BannerLoadingSkeleton,
  },
  spacer_component: {
    active: SDUISpacerRenderer,
  },
  header_component: {
    active: SDUIHeaderRenderer,
  },
  grid_component: {
    active: SDUIGridRenderer,
  },
};
